module.exports = __webpack_public_path__ + "img/sports.82978c48.png";